export default __webpack_public_path__ + "static/media/userError.1f064512.svg";